<template>
  <div id="app" v-title data-title="scPerturbDB">
    <!-- style="min-width:1000px;overflow-x: auto;" -->
    <!-- 上面的参数加到app里面可以控制内容的最低宽度,
     -->
    <a-layout style="min-height: 100vh; overflow-x: scroll">
      <a-layout>
        <!-- 此处的数值必须和上面的width一致 -->
        <a-layout-header
          :style="{
            position: 'fixed',
            // textAlign: 'left',
            // float: 'left',
            zIndex: 9999,
            width: '100%',
            paddingRight: '550px', //这个非常重要
          }"
        >
          <div
            class="logo"
            style="width: 160px; margin-left: 50px"
            @click="goHome()"
            onmouseover="this.style.cursor='pointer'"
          >
            PerturbDB
          </div>
          <!-- 写一个margin-left 但是长度增大一点试试 -->
          <a-menu
            theme="dark"
            mode="horizontal"
            :default-selected-keys="['1']"
            :selected-keys="this.selectKey"
            :style="{
              lineHeight: '64px',
              width: '140%',
              textAlign: 'left',
              fontSize: '15px',
            }"
          >
            <a-menu-item class="suojin">
              <a-input-search
                size="large"
                placeholder="Input a gene name"
                style="width: 120%; padding: 0 -10px 0 -10px"
                v-model="quickValue"
                @search="onSearch"
              />
            </a-menu-item>
            <a-menu-item
              key="1"
              @click="changekeys('1')"
              style="margin-left: 40px"
              class="suojin"
            >
              Home <router-link to="/home"></router-link
            ></a-menu-item>
            <a-menu-item key="0" @click="changekeys('0')" class="suojin">
              Gene<router-link to="/genes"></router-link>
            </a-menu-item>
            <a-menu-item key="5" @click="changekeys('5')" class="suojin">
              Dataset <router-link to="/publications"></router-link
            ></a-menu-item>
            <a-menu-item key="3" @click="changekeys('3')" class="suojin">
              Perturbation cluster<router-link to="/fclusters"></router-link>
            </a-menu-item>
            <!-- 此处隐藏 -->
            <a-menu-item key="onco" @click="changekeys('onco')" class="suojin">
              Cancer hallmarks<router-link to="/oncopheno"></router-link>
            </a-menu-item>
            <a-menu-item key="4" @click="changekeys('4')" class="suojin">
              Inhibitor<router-link to="/inhibitor"></router-link>
            </a-menu-item>
            <a-menu-item key="6" @click="changekeys('6')" class="suojin">
              Cancer<router-link to="/cancers"></router-link
            ></a-menu-item>
            <a-sub-menu key="7">
              <!-- <a-icon type="tool" /> -->
              <span slot="title">Tools</span>
              <a-menu-item @click="changekeys('7')"
                >PGSEA<router-link to="/PGSEA"></router-link
              ></a-menu-item>
              <a-menu-item @click="changekeys('7')"
                >DrawCorrHeatmap<router-link
                  to="/DrawCorrHeatmap"
                ></router-link>
              </a-menu-item>
              <!-- <a-menu-item @click="changekeys('7')"
                >Primer finder<router-link to="/primerFinder"></router-link>
              </a-menu-item> -->
              <!-- <a-menu-item @click="changekeys('7')"
                >Dataset collection<router-link
                  to="/datasetlinks"
                ></router-link>
              </a-menu-item> -->
            </a-sub-menu>
            <a-menu-item key="9" @click="changekeys('9')">
              Download<router-link to="/download"></router-link>
            </a-menu-item>
            <a-menu-item key="8" @click="changekeys('8')">
              Help<router-link to="/help"></router-link>
            </a-menu-item>
          </a-menu>
        </a-layout-header>
        <a-layout-content
          :style="{
            padding: '80px 25px 25px 25px',
            backgroundColor: 'white',
            overflow: 'initial',
          }"
        >
          <!--此处是内容页的展示路由-->
          <router-view></router-view>
        </a-layout-content>
        <a-layout-footer :style="{ background: '#f5f5f5' }">
          <div class="footer">
            <a-row>
              <a-col :span="24" offset="0" style="line-height: 20px">
                Copyright &copy; 2022-2025, Bioinformatics Center, Sun Yat-sen
                Memorial Hospital, Sun Yat-sen University, China. All Rights
                Reserved.</a-col
              >
              <!-- <a-col :span="8"
                ><a
                  href="https://clustrmaps.com/site/1bn83"
                  title="Visit tracker"
                  ><img
                    src="//www.clustrmaps.com/map_v2.png?d=h6WZVFnLpgaKFkVf8ZSkGaME2LqqM9og6GCA1PjsiAU&cl=ffffff"
                    width="200"
                    height="100"
                /></a>
              </a-col> -->
            </a-row>
          </div>
        </a-layout-footer>
      </a-layout>
    </a-layout>
    <a-back-top />
    <!-- to top 按钮,需要的时候才会出现-->
  </div>
</template>

<script>
export default {
  methods: {
    onSearch() {
      if (this.quickValue != "") {
        let routeData = this.$router.resolve({
          name: "quickSearch",
          query: { gene: this.quickValue },
        });
        window.open(routeData.href, "_blank");
        this.value = "";
      }
    },
    changekeys(value) {
      this.selectKey = value;
    },
    goHome() {
      this.$router.push({
        name: "Home",
      });
      this.selectKey = "1";
    },
  },
  data() {
    return {
      collapsed: false,
      selectKey: "",
      //快速查找的基因
      quickValue: "",
    };
  },
};
</script>
<style scpoed>
#app .logo {
  text-align: center;
  font-size: bold;
  width: 120px;
  height: 31px;
  font-size: 25px;
  line-height: 30px;
  background: white;
  margin: 16px 24px 16px 0;
  float: left;
  margin-left: 20%;
  border-radius: 5px;
}
.footer {
  text-align: center;
  font-size: 15px;
  line-height: 10px;
}
.suojin {
  margin-left: -12px;
}
</style>
